module.exports = __webpack_public_path__ + "img/17a003-09.cc34cbfd.png";